export default "__VITE_ASSET__DgAdmdnE__"